export const isOutOfView = (element) => {
  const rect = element.getBoundingClientRect();
  const halfScreenHeight = window.innerHeight / 3;

  return (
    rect.bottom < -halfScreenHeight ||
    rect.top > window.innerHeight + halfScreenHeight
  );
};

// export const filterArtObjects = (artObjects, subcategory) => {
//   console.log("objHighlighted", subcategory.objHighlighted);
//   return artObjects.filter((obj) =>
//     obj.collectionChosen.some(
//       (chosen) => chosen.subCategoryTitle.en === subcategory.subCategoryTitle.en
//     )
//   );
// };

export const filterArtObjects = (artObjects, subcategory) => {
  if (subcategory.objHighlighted) {
    const highlightedStockNumbers = subcategory.objHighlighted.map(
      (item) => item.stockNumber
    );

    const matchingArtObjects = artObjects.filter((obj) => {
      return obj.collectionChosen.some(
        (chosen) =>
          chosen.subCategoryTitle.en === subcategory.subCategoryTitle.en
      );
    });

    const orderedArtObjects = highlightedStockNumbers
      .map((stockNumber) =>
        matchingArtObjects.find((obj) => obj.slug.current === stockNumber)
      )
      .filter((obj) => obj !== undefined);
    const remainingArtObjects = matchingArtObjects.filter(
      (obj) => !highlightedStockNumbers.includes(obj.slug.current)
    );

    const finalArtObjects = orderedArtObjects.concat(remainingArtObjects);

    return finalArtObjects;
  }

  return artObjects.filter((obj) =>
    obj.collectionChosen.some(
      (chosen) => chosen.subCategoryTitle.en === subcategory.subCategoryTitle.en
    )
  );
};

export const scrollToElement = (scrollRef) => {
  if (scrollRef && scrollRef.current) {
    // Get the element's top position relative to the viewport
    const elementTop = scrollRef.current.getBoundingClientRect().top;

    // Calculate the offset in pixels. 10vh into pixels.
    // window.innerHeight gives the viewport height. 10% of viewport height is 10vh.
    const offset = (14 / 100) * window.innerHeight;

    // Calculate the position where you want to scroll.
    // window.pageYOffset gives the number of pixels that the document is currently scrolled vertically.
    // Subtract the offset to scroll 10vh above the element.
    const scrollToPosition = elementTop + window.pageYOffset - offset;

    // Use window.scrollTo to scroll to the specific position with smooth behavior.
    window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
  }
};
